import { useEffect } from 'react';

export default function useInitUI() {
    useEffect(() => {
        const scripts = [
            'assets/js/jquery.min.js',
            'assets/js/bootstrap.min.js',
            'assets/js/jquery.nice-select.min.js',
            'assets/js/slick.min.js',
            'assets/js/jquery.counterup.min.js',
            'assets/js/waypoints.js',
            'assets/js/jquery.meanmenu.min.js',
            'assets/js/jquery.magnific-popup.min.js',
            'assets/js/inview.min.js',
            'assets/js/wow.js',
            'assets/js/tilt.jquery.js',
            'assets/js/isotope.min.js',
            'assets/js/scrolltotop.min.js',
            'assets/js/plugins.js',
            //'assets/js/animations.js',
            'assets/js/custom.js'
        ];

        const loadedScripts = [];

        scripts.forEach(src => {
            const script = document.createElement('script');
            script.src = `/${src}`;
            script.async = false;
            document.body.appendChild(script);
            loadedScripts.push(script);
        });

        return () => {
            loadedScripts.forEach(script => {
                document.body.removeChild(script);
            });
        };
    }, []);
}
